<template>
    <div class="title">
        <h2>{{ title }}</h2>
        <img v-if="checked" src="@/assets/images/M3/M3Sketch/checkmark.png" class="title-icon">
        <img v-else src="@/assets/images/M3/M3Sketch/warn.png" class="title-icon">
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            title: null,
            checked: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
            };
        },
    }
</script>

<style scoped>
.title h2{
    font-size: 29px;
    color: #896a86;
    font-weight: 500;
    text-align: right;
    opacity: 0.8;
    margin-bottom: 20px;
}
.title{
    position: relative;
}
.title img{
    position: absolute;
    right: -20px;
    top: 0;
    display: block;
}
@media screen and (max-width: 1150px) {
    .title h2 {
        font-size:20px!important;
    }
}
</style>